// Staging form ID
const STAGING_COMING_SOON_FORM_ID = 'WeRUaP';
// Production form ID
const PROD_COMING_SOON_FORM_ID = 'RkVYgn';

export default function getComingSoonFormId() {
  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction) {
    return PROD_COMING_SOON_FORM_ID;
  }

  return STAGING_COMING_SOON_FORM_ID;
}
